/**
 * Textes de /v20. Argumentaire repris uniquement de jointherealworld.com (refs/v20/site-texte.md)
 * et des 20 captures FR (refs/v20/*.jpg|png), réécrit en tutoiement OpenBro.
 * Leurs chiffres sont remplacés par les faits OpenBro (appel mensuel, plan 30 jours, 6 formations,
 * communauté, Gaut, 49 €/mois, 99 € barré). Ajouts libres : créneau, réservation, paiement, résiliation.
 * `**mot**` = blanc gras, le reste en gris. `^^mot^^` = mot orange dans un titre (réf. image 08).
 */

const COPY = {
  // Header
  menu: 'Menu',
  login: 'Se connecter',
  nav: [['#etapes', 'Les étapes'], ['#voies', 'Leur façon contre la nôtre'], ['#formations', 'Les formations'], ['#choix', 'Le prix'], ['#faq', 'FAQ']],

  // CTA + ligne de preuve (réf. images 01, 07, 12, 15, 20)
  cta: 'Rejoins OpenBro',
  ctaTheirs: 'Fais-le à leur façon',
  ctaYours: 'Fais-le à ta façon',
  proof: '**Gaut, la communauté et 6 formations** t’attendent',

  // Hero (site : « The Fastest Path To Success / Make Money & Level Up / Generate an income now… »)
  heroTitle: 'OpenBro : le chemin le plus rapide **vers la réussite**',
  heroSub: 'Passe au niveau supérieur dès ce mois-ci',
  heroLead: 'Avance **dès maintenant** avec un mentor, un plan de 30 jours et 6 formations, dans un appel privé chaque mois.',

  // Trois pastilles (site : world class Learning / scale from zero / 1-on-1 advice From Experts)
  pills: [['Un plan', 'pour 30 jours'], ['Partir de zéro', '6 formations'], ['Conseil en tête-à-tête', 'avec Gaut']],

  // Avis (site : « Our Student Reviews » + cartes qui défilent). Pas de note ni de nouvel avis :
  // les cartes reprennent les messages déjà en ligne sur OpenBro (mises en situation, cf. FAQ).
  reviewsTitle: 'Ce que disent **les bros**',
  reviewsNote: 'Mises en situation',

  // Offres (site : « Our Plans / 98% Sold Out / earn prosper conquer »). Pas de pourcentage inventé :
  // une seule offre, liée au créneau réel.
  plansKicker: 'Notre offre',
  plansLabel: 'Offre de lancement',
  plansTitle: 'Une seule formule. **Le créneau part vite.**',
  plan: { name: 'OpenBro', items: ['Un appel privé chaque mois', 'Ton plan des 30 jours', '6 formations + la communauté'] },

  // 1. Trois étapes (image 01)
  stepsPill: 'Triphasé',
  stepsTitle: 'Transformation **de ta vie**',
  steps: [
    ['Étape 1', 'Choisis ton créneau et rejoins OpenBro'],
    ['Étape 2', 'Connecte-toi à la communauté et à Gaut'],
    ['Étape 3', 'Exécute ton plan des 30 jours : alimentaire, entraînement, business'],
  ],

  // 2. Le plan de sortie (image 02)
  exitTitle: 'Le plan de sortie qu’on ne t’a **jamais appris**',
  exit: [
    '**En réalité, ce système n’a jamais été conçu pour ta réussite.** Il a été conçu pour te maintenir dans la dépendance : aux salaires, aux politiques, aux promesses qui ne se réalisent jamais.',
    '**OpenBro n’est pas une simple plateforme,**',
    'c’est un nouveau mode de vie. Tu y apprends de véritables compétences. Tu es accompagné par Gaut, chaque mois. **Tu développes ta trésorerie, ton indépendance et, surtout, tu reprends le contrôle de ta vie.**',
  ],
  exitGridTitle: 'Nos formations',

  // 3. Leur façon contre la nôtre (image 03)
  waysPill: 'Deux voies à suivre',
  waysTitle: 'Leur façon de faire ~~contre~~ notre façon de faire',
  theirTitle: 'Leur façon',
  theirs: [
    'Tu cherches sur YouTube depuis des heures',
    'Des conseils aléatoires, sans structure',
    'Tu te retrouves bloqué sans aucune aide',
    'Aucune idée de ce qui fonctionne réellement',
    'Personne à qui poser des questions',
    'Entouré de faible énergie',
  ],
  ours: [
    'Un appel privé avec Gaut chaque mois',
    '6 formations',
    'Une communauté qui avance avec toi',
    'Des tâches claires et un chemin vers les résultats : ton plan des 30 jours',
    'Plan alimentaire, entraînement, business',
    'Résiliable à tout moment',
  ],
  versus: 'Contre',

  // 4. Témoignages (image 04)
  storiesPill: 'Ce qui nous distingue',
  storiesTitle: 'Des témoignages **de réussite**',
  storiesQ: 'Qu’est-ce qui distingue ces membres des autres ?',
  storiesBody: [
    'Ils ont pris une décision et ne l’ont jamais regrettée. Grâce à un mentor, à des stratégies éprouvées et à une communauté,',
    'OpenBro te donne tout ce dont tu as besoin pour avancer et accéder à une véritable liberté, **dès le premier jour.**',
  ],
  stories: { adam: '100 kg au squat', ines: 'Meal prep le dimanche', theo: 'Site en ligne en 30 jours', lucas: 'Debout à 6 h 30' },
  prev: 'Précédent',
  next: 'Suivant',

  // Diplôme (site : « earn your signed diploma »). Pas de diplôme réel chez OpenBro :
  // on garde l'idée « ce que tu obtiens en allant au bout ».
  diplomaPill: 'Va au bout',
  diplomaTitle: 'Ce que tu obtiens **en allant au bout**',
  diploma: 'Ce n’est qu’en alliant **un travail acharné à des outils de classe mondiale** que tu auras une chance d’atteindre la liberté dont tu as toujours rêvé.',
  diplomaList: ['Ton plan des 30 jours exécuté', 'Une communauté de gens qui partagent les mêmes idées', 'Deviens maître de ton domaine'],

  // 5. Le monde change (images 05, 06, 07)
  worldPill: ['Nouveautés :', 'Présentation d’OpenBro'],
  worldTitle: 'Le monde est sur le point de changer.',
  time: { pill: 'Le temps presse', title: 'Le temps t’est **compté**', body: ['Le monde changera à jamais. On développe sans cesse de nouveaux moyens de **te piéger.**', '**Qu’as-tu fait pour te préparer ?** Il faut bien comprendre : c’est maintenant ou jamais.'] },
  ai: { pill: 'La prise de contrôle', title: 'Prise de contrôle **imminente par l’IA**', body: ['Imagine une potion magique pour ton entreprise qui décuplerait **ta productivité du jour au lendemain.** Un robot pourrait générer des revenus pendant ton sommeil… Pourtant, tu restes les bras croisés.'] },
  skill: { pill: 'La sortie', title: 'Tu dois acquérir **une nouvelle compétence**', body: ['Imagine… Les opportunités qui s’offrent à toi lorsque tu investis en toi-même : un revenu plus élevé, une plus grande liberté et la possibilité de créer la vie dont tu rêves. **N’attends pas que le succès vienne à toi. Prends ton destin en main.**'] },

  // 6. Réserve pour l'année (image 08)
  yearPill: 'Un an suffit.',
  yearTitle: '^^Réserve^^ pour l’année prochaine',
  year: [
    'Tu peux changer de vie en seulement un an de concentration…',
    '**mais seulement** si tu investis ton énergie au bon endroit, en utilisant les bonnes informations.',
    'Dans OpenBro, Gaut te donne **un plan d’action détaillé** pour atteindre tes objectifs le plus rapidement possible : un appel chaque mois, un plan des 30 jours.',
  ],

  // 7. Deux voies (image 09)
  pathsPill: 'Nouveautés : présentation d’OpenBro',
  pathsTitle: 'Deux voies s’offrent à toi',
  stayKicker: 'Échec de la réalisation',
  stayTitle: 'Reste stagnant',
  stay: 'Suis le parcours classique, en investissant des années dans un travail qui ne t’intéresse pas, pour un patron que tu n’aimes pas, pour un salaire médiocre, juste pour pouvoir prendre ta retraite dans 50 ans.',
  payKicker: 'Payer',
  pay: 'Accède immédiatement à ton plan, à Gaut et aux 6 formations, et accélère ton chemin.',

  // 8. Les formations (images 10, 11)
  coursesPill: 'Les formations OpenBro',
  coursesTitle: '6 formations pour avancer',
  courses: {
    ia: ['IA & Automatisation', 'Faire bosser plusieurs modèles pour toi, et vendre des services IA.'],
    startup: ['Startup', 'Ton idée, ici, trouve son associé. Un bro pour lancer le projet avec toi.'],
    reseaux: ['E-commerce & Réseaux sociaux', 'Imagine lancer une boutique et te connecter à ton marché dès le lendemain matin. Lancer ta marque, vendre en ligne.'],
    montage: ['Montage vidéo', 'À l’ère du numérique, la valeur des vidéos est essentielle. Le rythme qui retient, les accroches qui arrêtent le scroll, un rendu pro.'],
    musculation: ['Musculation & Discipline', 'Un esprit sain dans un corps sain. De zéro à intermédiaire : technique, programmation, progression.'],
    nutrition: ['Nutrition & Performance', 'La santé est un trésor. Alimentation, suppléments et un système simple à tenir.'],
  },

  // 9. Nouvelles compétences (image 12)
  newSkills: ['Lorsqu’une nouvelle technologie révolutionne un secteur,', '**OpenBro est l’endroit où apprendre à en tirer parti.**', 'Les formations sont mises à jour régulièrement.'],

  // 10. Nos élèves gagnent (site + image 12 bas)
  winsPill: 'OpenBro l’emporte.',
  winsTitle: 'Nos membres **gagnent**',

  // 11. Prêt à travailler dur (image 13)
  workPill: 'Pose-toi la question',
  workTitle: 'Es-tu prêt à **travailler dur ?**',
  work: [
    '**Avancer est une compétence.** Comme toute compétence, elle s’apprend, et la vitesse d’apprentissage dépend de ton implication, de ton mentor et de l’environnement dans lequel tu apprends.',
    '**Gaut utilise ce qu’il enseigne,** il sait ce qu’il faut pour avancer.',
    '**Il n’existe pas de meilleur endroit pour apprendre à te construire aujourd’hui.**',
  ],

  // 12. Tu auras accès à (images 14, 15)
  accessTitle: 'Tu auras accès à',
  access: [
    { title: 'Apprentissage étape par étape', phone: 'formations', items: ['**Programme facile à suivre**', 'De nouvelles leçons sont ajoutées régulièrement', 'Apprends sur mobile et ordinateur'] },
    { title: 'Un appel privé chaque mois', phone: 'call', items: ['**Un appel en tête-à-tête avec Gaut**', 'Ton créneau, **choisi avant de payer**', 'Ton plan des 30 jours : **alimentaire, entraînement, business**'] },
    { title: 'Une communauté exclusive', phone: 'bros', items: ['Bénéficie **d’un mentorat à chaque étape** de ton parcours', 'Des bros qui avancent avec toi', 'Entre en contact avec **la communauté OpenBro**'] },
  ],

  // 13. Le choix (image 16)
  choiceTitle: 'Le choix t’appartient.',
  nothingTitle: 'Ne rien faire',
  nothingSub: 'Regarde Netflix',
  nothingCost: 'Perdre 8 heures par jour',
  nothing: ['Travailler pour quelqu’un d’autre (8 h par jour)', 'Rester immobile', 'Travail de 9 h à 17 h', 'Rester insatisfait', 'Fréquenter les ratés'],
  nothingHref: 'https://www.netflix.com',
  actTitle: 'Agis',
  actSub: 'Commence dès aujourd’hui',
  act: ['Un appel privé avec Gaut chaque mois', 'Ton plan des 30 jours : alimentaire, entraînement, business', '6 formations', 'La communauté', 'Aucune expérience requise', 'Sur mobile et ordinateur'],
  cancel: 'Annulation sans frais à tout moment',
  lockPrice: (price) => `${price}/mois`,
  lockNote: 'Bloque ton prix avant qu’il n’augmente.',
  period: '/mois',

  // 14. Bloque ton prix (image 17)
  lockPill: 'Bloque ton prix',
  lock: ['**C’est le moment idéal pour bloquer ton prix et profiter de cette offre avant qu’il ne soit trop tard.**', 'Ton créneau, ton plan, Gaut : tout commence par un appel.', '**Bloque ton prix dès maintenant avant qu’il n’augmente.**'],

  // 15. FAQ (images 18, 19, 20) + réponses déjà en ligne sur OpenBro
  faqPill: 'Tu réfléchis encore ?',
  faqTitle: 'Foire aux questions',
  faq: [
    ['OpenBro fonctionne-t-il ?', 'Oui, pour les membres actifs. Ici, **ta réussite dépend de ton implication.** Tu y trouves ce que l’école ne t’a jamais offert : quelqu’un qui te dit quoi faire ensuite, et qui t’aide au quotidien en cas de difficulté.'],
    ['Combien coûte OpenBro, et qu’est-ce qu’il contient ?', '**49 € par mois**, au lieu de 99 €. Un appel privé avec Gaut chaque mois, ton plan des 30 jours, les 6 formations et la communauté. **Tout est inclus.**'],
    ['Je n’ai aucune expérience et peu de temps. Est-ce fait pour moi ?', 'C’est précisément pour ce public que le programme a été conçu. **Les formations partent de zéro**, et l’appel part de **ta situation**, pas d’un programme standard. Tu n’as pas besoin d’être prêt, **tu as juste besoin de commencer.**'],
    ['Que se passe-t-il si je suis bloqué ?', 'Tu poses ta question, et quelqu’un qui est déjà passé par là te répond. Tu as la communauté, et chaque mois, ton appel avec Gaut. **Ici, tu n’es jamais seul.**'],
    ['Comment je rejoins OpenBro, et quand je peux commencer ?', 'Tu choisis ton créneau, tu paies, et **tu as accès à tout immédiatement.** Tu actives ton compte avec ton prénom et ton email, et tu te connectes avec un code reçu par email. **Ce qu’on te promet, c’est que tu sauras exactement quoi faire ensuite.**'],
    ['C’est pour qui ?', 'Pour toi si tu veux avancer sur **ton business, ton argent, ton corps ou ta vie perso**, et que tu es prêt à passer à l’action. **Si tu cherches une formule magique, tu l’as trouvée.**'],
    ['Tu garantis des résultats ?', 'Oui. **Je t’apporte un plan, un regard extérieur et un cadre.** Les résultats, tu les as.'],
    ['Et si ce n’est pas pour moi ? Je peux annuler ?', 'Oui, à tout moment. **L’abonnement est sans engagement.** Les mois déjà payés ne sont pas remboursés. Si tu es arrivé sur cette page, c’est que tu prends un risque : **tu perds un mois. Rester comme tu es te coûte plus cher.**'],
    ['Les vidéos et les messages, c’est qui ?', 'Ce sont **des mises en situation**, pas des membres filmés ni de vraies conversations. Les formations et les écrans de l’espace membre, eux, **viennent du vrai produit.**'],
  ],

  // Footer (image 20)
  footerBrand: 'OpenBro',
  footerTag: 'by Gaut Bonac',
  help: 'Besoin d’aide ?',
  terms: 'Conditions d’utilisation',
  privacy: 'Politique de confidentialité',
  disclaimer: 'Tout ce qui est enseigné dans OpenBro a une visée éducative. C’est à chaque membre d’appliquer et de faire le travail.',

  // Toasts (même forme que les images). Pas de faux membre : ils rappellent le créneau réel et l'offre.
  toasts: [
    (slot) => ['Bienvenue dans OpenBro', `Ton créneau : ${slot}`, 'Encore libre'],
    () => ['Bienvenue dans OpenBro', 'Offre de lancement', '49 €/mois au lieu de 99 €'],
    () => ['Bienvenue dans OpenBro', 'Sans engagement', 'Résiliable à tout moment'],
  ],

  // Créneau (ajout libre autorisé)
  slotLine: (label) => `Ton créneau : **${label}**`,
  bookCta: (label) => `Réserver ${label}`,
  secure: 'Paiement sécurisé par Stripe',
};

export default COPY;
